import React, { useState } from "react";
import { Button, Field, Form } from "@bwevents/components";
import { Validations } from "../services/Validations";
import "./Newsletter.scss";

export default function Newsletter({ api, messenger }) {
  const [email, setEmail] = useState();
  const emailValid = email !== "" ? Validations.isEmail(email) : "";
  const onSubmit = () => {
    api(`api/providers/${process.env.REACT_APP_SLUG}/newsletter/signin/`, {
      method: "POST",
      body: {
        email: email,
        client: process.env.REACT_APP_SLUG,
      },
    }).then(({ ok }) => {
      if (ok) {
        setEmail(null);
        messenger({
          severity: "success",
          detail: "Succssesfully done.",
          life: 3000,
        });
      }
    });
  };

  return (
    <div className="newsletter">
      <div className="bw-event-container">
        <h2>Join our newsletter!</h2>

        <Form className="bw-event-form">
          <Field
            className="bw-event-input"
            placeholder="Email address"
            type="text"
            value={email}
            setValue={setEmail}
            required
            invalid={email === "" || emailValid === false}
            invalidMessage={
              (email === "" ? "Email is required." : "") ||
              (!emailValid ? "Email is invalid." : "")
            }
          />
          <Button
            label="Join us!"
            className="bw-settings-integrations-btn-save"
            disabled={!emailValid}
            onClick={onSubmit}
          />
        </Form>
      </div>
    </div>
  );
}
